import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import About from '../About/About'
import Contact from '../Contact/Contact'
import Header from '../Header/Header'
import TabsComponent from '../TabsComponent/TabsComponent'
import News from '../News/News'

const Landing = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }, [location.hash]);

  return (
    <div style={{ overflowX: 'hidden', minWidth: '100%', maxWidth: '100vw' }}>
      <Header />
      <About />
      <TabsComponent />
      <News />
      <Contact />
    </div>
  )
}

export default Landing